import React, { useCallback } from 'react';

import { Flex } from '@chakra-ui/react';
import { updateOKR } from 'components/RabbitOKRCreationPanel/OKRCreationPanelSlice';
import { OKROwnerAndCollaboratorComponent } from 'components/RabbitOKRSidePanel/PrimaryPanel/Sections/Details/OKROwnerAndCollaborator';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { kRDrawerSecondaryPanelSelector } from 'selectors/krSecondaryPanel';
import { okrCreationPanelStateSelector } from 'selectors/okrCreationPanelSelector';

interface Props {}

const OwnersSection = ({}: Props) => {
  const secondaryPanelDetailsObject = useSelector(kRDrawerSecondaryPanelSelector);
  const okrDetails = useSelector(okrCreationPanelStateSelector);
  const dispatch = useDispatch();

  const onChange = useCallback(
    (updates) => {
      dispatch(updateOKR(updates));
    },
    [dispatch]
  );

  const { toIds } = okrDetails;

  return (
    <Flex
      sx={{
        '.owners-collabs': {
          width: '100%',
          minHeight: '44px',
        },
      }}
      mb="16px"
    >
      <OKROwnerAndCollaboratorComponent
        isOwner
        ownersAndCollaborators={toIds}
        // @ts-ignore
        onChange={(toIds) => onChange({ toIds })}
        showName
        showIcon
      />
    </Flex>
  );
};

export { OwnersSection };
